import api from './api';

export const atoDebtAPI = {
  dashboard: () => api.get('/api/ato-debts/dashboard'),
  list: (params) => api.get('/api/ato-debts', { params }),
  create: (data) => api.post('/api/ato-debts', data),
  get: (id) => api.get(`/api/ato-debts/${id}`),
  update: (id, data) => api.patch(`/api/ato-debts/${id}`, data),
  delete: (id) => api.delete(`/api/ato-debts/${id}`),
  getPaymentPlan: (debtId) => api.get(`/api/ato-debts/${debtId}/payment-plan`),
  createPaymentPlan: (debtId, data) => api.post(`/api/ato-debts/${debtId}/payment-plan`, data),
  updateInstalment: (instalmentId, status) => api.patch(`/api/payment-instalments/${instalmentId}`, { status }),
  // B#18 — DPN risk + correspondence
  getRisk: (debtId) => api.get(`/api/ato-debts/${debtId}/risk`),
  riskSummary: () => api.get('/api/ato-risk-summary'),
  listCorrespondence: (debtId) => api.get(`/api/ato-debts/${debtId}/correspondence`),
  addCorrespondence: (debtId, data) => api.post(`/api/ato-debts/${debtId}/correspondence`, data),
  deleteCorrespondence: (debtId, corrId) => api.delete(`/api/ato-debts/${debtId}/correspondence/${corrId}`),
};

export const RISK_LEVEL_COLORS = {
  none: 'bg-muted text-muted-foreground',
  low: 'bg-green-100 text-green-700',
  medium: 'bg-amber-100 text-amber-700',
  high: 'bg-orange-100 text-orange-700',
  critical: 'bg-red-100 text-red-700',
};

export const CORRESPONDENCE_TYPE_LABELS = {
  notice: 'ATO Notice',
  dpn_warning: 'DPN Warning',
  payment_arrangement: 'Payment Arrangement',
  phone_call: 'Phone Call',
  letter: 'Letter',
  general: 'General',
};

export const ATO_DEBT_TYPE_LABELS = {
  income_tax: 'Income Tax',
  gst: 'GST',
  paygw: 'PAYG Withholding',
  super_guarantee: 'Super Guarantee',
  fbt: 'FBT',
  penalty: 'Penalty',
  interest: 'Interest',
  other: 'Other',
};

export const ATO_DEBT_STATUS_COLORS = {
  outstanding: 'bg-red-100 text-red-700',
  payment_plan: 'bg-amber-100 text-amber-700',
  paid: 'bg-green-100 text-green-700',
  remitted: 'bg-muted text-muted-foreground',
};
